import axiosInstance from '../utils/axiosInstance';

export interface SearchResult {
  cluster_id: number;
  headline: string;
  summary: string;
  tags: string[];
  language: string;
  website: string;
  publication_datetime: number;
  breaking_rating: number | null;
}

export interface SearchResponse {
  results: SearchResult[];
  found: number;
  search_time_ms: number;
  page: number;
  per_page: number;
}

export interface AutocompleteSuggestion {
  text: string;
  cluster_id?: number;
}

export interface AutocompleteResponse {
  suggestions: AutocompleteSuggestion[];
}

export const SearchService = {
  // Search for news clusters
  search: async (query: string, page: number = 1, perPage: number = 10): Promise<SearchResponse> => {
    const response = await axiosInstance.get('/search', {
      params: { q: query, page, perPage }
    });
    // Handle new response structure
    const data = response.data?.data || response.data;
    return data;
  },

  // Get autocomplete suggestions
  autocomplete: async (query: string, limit: number = 5): Promise<AutocompleteResponse> => {
    const response = await axiosInstance.get('/search/autocomplete', {
      params: { q: query, limit }
    });
    // Handle new response structure
    const data = response.data?.data || response.data;
    return data;
  },
};
